module.exports = __webpack_public_path__ + "img/background_1200.jpg?33b4526169fbf25ff2efe27850330c98";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/src/assets/img/background_1200.jpg
// module id = 64
// module chunks = 0